// extracted by mini-css-extract-plugin
export default {"BdroAlertError":"bdroLoginError-module_BdroAlertError_LmwkA"};